import Slider from '../../../../shared/ui/slider/Slider';
import s from './ZoomSlider.module.css';
import { useSelector } from 'react-redux';
import { selectSelectedImage } from '../../../../store/selectors/imageSelectors';
import { updateSelectedImageSetting } from '../../../../store/slices/imageSlice';
import { useAppDispatch } from '../../../../store/store';

const ZoomSlider = () => {
    const selectedImage = useSelector(selectSelectedImage);
    const dispatch = useAppDispatch();
    // const temporaryImage = useSelector(selectTemporaryImage);

    const zoom = selectedImage?.image?.transformation?.crop?.zoom ?? 1;
    const minZoom = 1;
    const maxZoom = 2;
    const zoomPercentage = Math.round(((zoom - minZoom) / (maxZoom - minZoom)) * 100);

    const onZoomChange = (value: number) => {
        if (!selectedImage?.image) return;

        dispatch(
            updateSelectedImageSetting({
                key: 'transformation',
                value: {
                    ...selectedImage.image.transformation,
                    crop: {
                        x: selectedImage.image.transformation?.crop?.x || 0,
                        y: selectedImage.image.transformation?.crop?.y || 0,
                        width:
                            selectedImage.image.transformation?.crop?.width ||
                            selectedImage.image.transformation?.width,
                        height:
                            selectedImage.image.transformation?.crop?.height ||
                            selectedImage.image.transformation?.height,
                        zoom: value,
                    },
                },
            }),
        );
    };

    if (!selectedImage?.image) {
        return null;
    }
    return (
        <div className={s.container}>
            <Slider
                value={selectedImage?.image?.transformation?.crop?.zoom || 1}
                onChange={onZoomChange}
                min={0.1}
                max={3}
                step={0.01}
            />
            <div className={s.zoom_level}>
                <p>Zoom Level:</p>
                <p>{zoomPercentage}%</p>
            </div>
        </div>
    );
};

export default ZoomSlider;
